import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { PromotionVm } from '@inyova/models';
import { TranslateService } from '@ngx-translate/core';

import { TranslateNumberPipe } from '@shared/pipes';

@Component({
  selector: 'app-referrals-dialog-share',
  templateUrl: './referrals-dialog-share.component.html',
  styleUrls: ['./referrals-dialog-share.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ReferralsDialogShareComponent {
  private translateService: TranslateService = inject(TranslateService);
  @Input() vm: PromotionVm;
  @Input() inviteText: string;
  @Output() referralShare: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeShare: EventEmitter<void> = new EventEmitter<void>();

  sharePlatforms = ['whatsapp', 'email', 'linkedin', 'facebook', 'twitter'];

  onClose() {
    this.closeShare.emit();
  }

  getMessage(sharePlatform: string, vm: PromotionVm) {
    let message = '';
    let incentiveAmount = '';

    if (vm.promo.referralMoneyMoneyMonthly > 0) {
      incentiveAmount = new TranslateNumberPipe().transform(
        vm.promo.referralMoneyMoneyMonthly * vm.promo.referralMoneyMonthsDuration,
        vm.language,
        vm.currency
      ) as string;
    } else {
      incentiveAmount = vm.promo.referralMonths.toString();
    }

    const platform = ['whatsapp', 'twitter'].includes(sharePlatform) ? 'whatsapp' : 'long';

    this.translateService
      .stream(`ACCOUNT.promotion.invite.share.${vm.promo.referralMoneyMoneyMonthly > 0 ? 'money' : 'months'}.${platform}`, {
        code: vm.referralCode,
        amount: incentiveAmount
      })
      .subscribe((res) => (message = res));

    return `${message}`;
  }

  onReferralShare(platform: string) {
    this.referralShare.emit(platform);
  }
}
